// App.jsx
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import UserLayout from "./components/UserLayout";
import AdminLayout from "./components/AdminLayout"; // ✅ new layout

import Hero from "./components/Hero";
import About from "./components/About";
import Specialities from "./components/Specialities";
import Review from "./components/Review";
import Contact from "./components/Contact";
import Gallery from "./components/Gallery";
import EyeServices from "./components/EyeServices";
import OrthoServices from "./components/OrthoServices";
import ReviewForm from "./components/ReviewForm";
import Login from "./pages/Login";
import ReviewMaster from "./pages/ReviewMaster";
import GalleryMaster from "./pages/GalleryMaster";
import Dashboard from "./pages/Dashboard";
import Sidebar from "./pages/Sidebar";
import ScrollToTop from "./components/ScrollTop";


const App = () => {
  return (
    <BrowserRouter>
          <ScrollToTop />

      <Routes>
        {/* User Panel */}
        <Route path="/" element={<UserLayout />}>
          <Route index element={<Hero />} />
          <Route path="about" element={<About />} />
          <Route path="specialities" element={<Specialities />} />
          <Route path="/review-form" element={<ReviewForm />} />
          <Route path="review" element={<Review />} />
          <Route path="contact" element={<Contact />} />
          <Route path="gallery" element={<Gallery />} />
          <Route path="eye-services/:id" element={<EyeServices />} />
          <Route path="ortho-services/:id" element={<OrthoServices />} />
        </Route>

        {/* Admin Panel */}
        <Route path="/admin" element={<Login />} >
        <Route path="/admin/dashboard" element={<Dashboard />} />
        <Route path="/admin/reviewmaster" element={<ReviewMaster />} />
        <Route path="/admin/gallerymaster" element={<GalleryMaster />} />
        </Route>
        {/* Login */}

       
      </Routes>
    </BrowserRouter>
  );
};

export default App;
